//  tailwind.config.ts
import { Config } from 'tailwindcss';
import { dxpUiPreset } from '@curtin-dxp/curtin-ui';
import { gridAreas } from 'tailwindcss-grid-areas';

const config: Config = {
  plugins: [gridAreas],
  presets: [dxpUiPreset],
  darkMode: 'class',
  content: ['./src/**/*.{ts,tsx}', './node_modules/@curtin-dxp/curtin-ui/**/*.{ts,tsx,js,jsx}'],
  theme: {
    // Curtin breakpoints
    screens: {
      'sm': '380px',
      'md': '768px',
      'md-to-lg': {'min': '768px', 'max': '1280px'},
      'lg': '1280px',
      'xl': '1528px',
      '2xl': '1920px',
      '3xl': '2560px',
    },
    extend: {
      boxShadow: {
        'card-shadow': '0 0 15px 0 rgba(0,0,0,0.2)',
      },
      keyframes: {
        'collapsible-down': {
          from: { height: '0' },
          to: { height: 'var(--radix-collapsible-content-height)' },
        },
        'collapsible-up': {
          to: { height: '0' },
          from: { height: 'var(--radix-collapsible-content-height)' },
        },
      },
      animation: {
        'collapsible-down': 'collapsible-down 0.2s ease-out',
        'collapsible-up': 'collapsible-up 0.2s ease-out',
      },
      colors: {
        'grey-10': 'rgba(162, 161, 168,0.1)',
        'tertiary-red': 'hsla(6, 100%, 68%, 1)',
        'secondary-grey-01': '#4B4B4B',
        'secondary-grey-02': '#717171',
        'secondary-grey-03': '#B3B3B3',
        'secondary-grey-04': '#E8E8E8',
        'secondary-grey-05': '#F0F0F0',
        'secondary-grey-06': '#414141',
        'primary-black-90': '#1A1A1A',
        'primary-website-background-colour': '#F7F7F7',
        'ring': '#5424e5',
        'focus-ring': '#e52592',
        'calendar-text': '#797B86',
        'calendar-text-muted': '#D6D8E1',
        'badge-yellow': '#FFF5B9',
        'badge-purple': '#D4C8F8 ',
        'badge-pink': '#F6B1D8    ',
        'badge-green': '#89E4B6',
        'highlight-bg': '#f1eefd',
        'highlight-border': '#DDD3FA',
        'highlight-divider': '#d2c6f8',
        'marker-grey': '#d9d9d9',
        'deep-blue--light': '#f1eefd',
        'strawberry': '#ff615e',
        'dark-magenta': '#CA2381',
      },
      fontSize: {
        'f-sm': ['clamp(0.875rem, 0.825rem + 0.25vw, 1rem)', 'clamp(1.25rem, 1.15rem + 0.45vw, 1.5rem)'],
        'f-xs': ['clamp(0.75rem, 0.7rem + 0.25vw, 0.875rem)', '1.25rem'],
      },
    },
  },
};

export default config;
